import React from "react";
import Property from "./Property";
import {Collapse, Row} from 'antd';
import {CaretRightOutlined} from '@ant-design/icons';
import './TownHouse.less';

const {Panel} = Collapse;

const Level = (props) => {

	let levelName = `Level ${props.data.name}`;
	if (props.data.name.includes('Ground')) {
		levelName = 'Ground';
	} else if (props.data.name.includes('Level')) {
		levelName = props.data.name;
	}

	return (
		<div className={'level'}>
			<Collapse
				bordered={false}
				defaultActiveKey={false}
				expandIcon={({isActive}) => <CaretRightOutlined rotate={isActive ? 90 : 0}/>}
				className="site-collapse-custom-collapse"
			>
				<Panel header={levelName} key={`${props.appName}-${props.index}`} className="site-collapse-custom-panel">
					<Row gutter={[16, 10]}>
						{props.data.apartments.map((property, index) => <Property key={index} data={property} status={props.status} statusChange={props.statusChange}/>)}
					</Row>
				</Panel>
			</Collapse>
		</div>
	);
};

export default Level;